import { createAPI } from '../../composable/useAPI';

export const usePartnerAPI = () => {
  const api = createAPI();

  const request = {
    partner: {
      get: async (params) => {
        return await api.get('/api/v2/partner', { params })
          .then((res) => { return res.data.data})
          .catch (err => {return false})
      },

      post: async (data) => {
        return await api.post('/api/v2/partner', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      put: async (data) => {
          return await api.put('/api/v2/partner', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      delete: async(params) => {
        const queryString = params.map((seq) => `partnerSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/partner?${queryString}`)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      }
    },
    partnerManager: {
      get: async (params) => {
        return await api.get('/api/v2/partner_manager', { params })
          .then((res) => { return res.data.data})
          .catch (err => {return false})
      },

      post: async (data) => {
        return await api.post('/api/v2/partner_manager', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      put: async (data) => {
          return await api.put('/api/v2/partner_manager', data)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      },

      delete: async(params) => {
        const queryString = params.map((seq) => `partnerManagerSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/partner_manager?${queryString}`)
          .then((res) => { return res.data.status === 200})
          .catch (err => {return false})
      }
    }
  };

  return {
    ...request
  };
}
